import { bundleSale, getCouponInfo, shopifyCartAdd, shortage, shopCR } from '../../common/utils/fetch.js'
import { copyString, isMobile, verifyEmail, createCartAndCheckout } from '../../common/utils/index.js'
import ProductDetailVideo from "./sections/product-detail-video/index.js"
import HelpToChoose from '../../common/snippets/help-to-choose/index.js'

class Product {
  constructor(el) {
    this.config = el;
    this.init()
  }

  // quantity action
  quantity(el, init) {
    let quantity_input = el.find("input");
    el.find(".iconfont").click(function(e) {
      e.preventDefault()
      let n = +el.find("input").val();
      switch ($(this).data("method")) {
        case "minus": n--; break;
        case "plus": n++; break;
      }
      if (n <= 1) {
        n = 1;
        el.find(".jackery-icon-minus").addClass("disabled")
      } else {
        el.find(".jackery-icon-minus").removeClass("disabled")
      }

      if(quantity_input.attr("max") && n > (Number(quantity_input.attr("max")))) {
        n = (Number(quantity_input.attr("max")));
        el.find(".jackery-icon-plus").addClass("disabled")
        if(document.querySelector(".add_cart_error_wrapper")) {
          document.querySelector(".add_cart_error_wrapper").textContent = pageInfo.strings.product.max_inventory_quantity_error || ''
        }
      } else {
        el.find(".jackery-icon-plus").removeClass("disabled")
        if(document.querySelector(".add_cart_error_wrapper")) {
          document.querySelector(".add_cart_error_wrapper").textContent = ''
        }
      }
      quantity_input.val(n)
    })

    // 监听具体数量, val最小值为1
    quantity_input.unbind("input");
    quantity_input.on("input", function() {
      const val = $(this).val()
      Number(val) <= 0 && quantity_input.val(1)
      if (val > 1) {
        el.find(".jackery-icon-minus").removeClass("disabled")
      } else {
        el.find(".jackery-icon-minus").addClass("disabled")
      }

      if(quantity_input.attr("max") && val > (Number(quantity_input.attr("max")) || 1)) {
        quantity_input.val(Number(quantity_input.attr("max")) || 1)
        el.find(".jackery-icon-plus").addClass("disabled")
        if(document.querySelector(".add_cart_error_wrapper")) {
          document.querySelector(".add_cart_error_wrapper").textContent = pageInfo.strings.product.max_inventory_quantity_error || ''
        }
      } else {
        el.find(".jackery-icon-plus").removeClass("disabled")
        if(document.querySelector(".add_cart_error_wrapper")) {
          document.querySelector(".add_cart_error_wrapper").textContent = ''
        }
      }
    })

    // 初始化
    if (init) {
      setTimeout(() => {
        let value = quantity_input.val() || 1;
        if (value <= 1) {
          value = 1;
          el.find(".jackery-icon-minus").addClass("disabled")
        } else {
          el.find(".jackery-icon-minus").removeClass("disabled")
        }

        if (quantity_input.attr("max") && value > (Number(quantity_input.attr("max")) || 1)) {
          quantity_input.val(Number(quantity_input.attr("max")) || 1)
          el.find(".jackery-icon-plus").addClass("disabled")
          if(document.querySelector(".add_cart_error_wrapper")) {
            document.querySelector(".add_cart_error_wrapper").textContent = pageInfo.strings.product.max_inventory_quantity_error || ''
          }
        } else {
          el.find(".jackery-icon-plus").removeClass("disabled")
          if(document.querySelector(".add_cart_error_wrapper")) {
            document.querySelector(".add_cart_error_wrapper").textContent = ''
          }
        }
      }, 300)
    }
  }

  // 更新 划线价格显示
  updateComparePrice(variant) {
    const { showDiscountAmount, discountAmountFormat }= $(".meta [data-compare-price]").data()
    
    if(Number(variant.compare_at_price_nomoney) > Number(variant.price_nomoney)) {
      $(".meta [data-compare-price]").html(`<span class="compare-price text-sm">${variant.compare_at_price}</span>`);

      if (!showDiscountAmount) return
      
      if($(".meta .product-price--discount_amount").length === 0) {
        const target_dom = document.createElement('span');
        target_dom.classList.add("product-price--discount_amount");
        document.querySelector(".product-price--compare").parentNode.insertBefore(target_dom, document.querySelector(".product-price--compare").nextSibling)
      } else {
        $(".meta .product-price--discount_amount").show();
      }

      // 格式化配置
      const [currency, off] = discountAmountFormat.split('()')
      $(".meta .product-price--discount_amount").text(`${currency || '$'}${(Math.floor((variant.compare_at_price_nomoney - variant.price_nomoney) / 100)).toFixed(0)} ${off}`);

      // try {
      //   $(".meta .product-price--discount_amount").text(`${formatMoney(variant.compare_at_price_nomoney - variant.price_nomoney, pageInfo.currency.money_format)} ${off}`);
      // } catch (error) {
      //   $(".meta .product-price--discount_amount").text(`${currency || '$'}${(Math.floor((variant.compare_at_price_nomoney - variant.price_nomoney) / 100)).toFixed(0)} ${off}`);
      // }
    } else {
      $(".meta .product-price--discount_amount").hide();
      $(".meta [data-compare-price]").html(`<span class="compare-price text-sm"></span>`);
    }
  }

  renderProductInfo(variant) {
    const section_id = document.querySelector(".product-main-block").getAttribute("data-section-id");
    const url = document.querySelector(".product-main-block").getAttribute("data-url");

    fetch(`${url}?variant=${variant.id}&section_id=${section_id}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      // 会员积分文案
      const destination_points = document.getElementById(`product-points-content--${section_id}`);
      const source_points = html.getElementById(`product-points-content--${section_id}`);
      if (source_points && destination_points) {
        destination_points.innerHTML = source_points.innerHTML;
      }
    })
  }

  // get bundle product
  async bundleProduct(skuId) {
    const me = this;
    const DOM = $(".essential-addons");
    const buyItNowAction = $(".buy-it-now-action")
    buyItNowAction.removeClass('unvisible')

    const essential = (el) => {
      el.each(function() {
        me.quantity($(this).find(".operate"));
      })
      // monitor checkbox
      el.find('input[type="checkbox"]').change(function() {
        let index = +$(this).data("index");

        if ($(this).is(':checked')) {
          el.eq(index).addClass("active")

          buyItNowAction.addClass('unvisible')
        } else {
          el.eq(index).removeClass("active")

          buyItNowAction.removeClass('unvisible')

          el.siblings().each(function() {
            if ($(this).hasClass('active')) {
              buyItNowAction.addClass('unvisible')
              return false
            }
          });
        }
      })
    }

    const { data, } = await bundleSale({ shopifyShopId: shopId, skuId })
    if (data?.haveBundleSale && data?.goodsList && data?.goodsList.length) {
      let html = "";
      data.goodsList.forEach((item, index) => {
        // 捆绑产品的延保信息
        let warranty = "";
        if (item.productWarranty) {
          const extendedWarranty = item.extendedWarranty ? JSON.parse(item.extendedWarranty)[0] : 1;
          const defaultWarranty = item.defaultWarranty ? JSON.parse(item.defaultWarranty)[0] : 2;
          warranty += `<input type="checkbox" name="${item.title}" value="${item.skuId}" data-index="${index}" data-extended_warranty="${extendedWarranty}" data-default_warranty="${defaultWarranty}" />`
        } else {
          warranty += `<input type="checkbox" name="${item.title}" value="${item.skuId}" data-index="${index}" />`
        }
        html += `
          <li>
            <label>
              ${warranty}
              <figure class="flex-1 justify-between">
                <img src="${me.formatIMG(item.image)}" alt="${item.title}">
                <figcaption class="text-base">
                  <div class="text-overflow-3 title" title="${item.title}">${item.title}</div>
                  <div class="flex items-center justify-between">
                    <i>${item.priceDesc}</i>
                    <span class="operate">
                      <i class="iconfont jackery-icon-minus disabled" data-method="minus"></i>
                      <input type="number" name="extra-quantity" value="1" min="1">
                      <i class="iconfont jackery-icon-plus" data-method="plus"></i>
                    </span>
                  </div>
                </figcaption>
              </figure>
            </label>
          </li>
        `;
      })
      DOM.find(".text-base").text(data.title).attr("title", data.title);
      DOM.find("ul").html(html);
      DOM.show();
      essential(DOM.find("ul li"))
    } else {
      DOM.find("ul").empty();
      DOM.hide()
    }
  }

  formatIMG(url) {
    const _last = url.split('.').pop()
    return `${url.slice(0, url.lastIndexOf("."))}_120x.${_last}`
  }

  getCheckedItems(flag) {
    const $form = $(`#AddToCartForm-${meta.product.id}`)
    let { propertiesWarranty, warrantyContent } = this.config;
    // propertiesWarranty.match(/(?<=\[)(.+?)(?=\])/g); 不兼容
    let field = propertiesWarranty.replace("properties[", "").replace("]", "");

    let items = [];

    // add base product
    const base = {
      id: Number($form.find("input[name='id']:checked").val()),
      quantity: Number($form.find("input[name='quantity']").val()),
      properties: {}
    };
    // base.properties[field] = $form.find(`input[name='${propertiesWarranty}']`).val();  暂时不需要再购物车显示延保信息
    items.push(base);

    // add extra product
    $(".essential-addons input[type='checkbox']:checked").each(function() {
      let v = {
        id: Number($(this).val()),
        quantity: Number($(this).parent().find("input[name='extra-quantity']").val()),
        properties: {}
      };
      let ex = $(this).data("extended_warranty"), de = $(this).data("default_warranty");
      if (ex && de) {
        let total = Number(ex) + Number(de);
        // v.properties[field] = warrantyContent.replace("{{ total }}", total).replace("{{ extended }}", ex)  暂时不需要再购物车显示延保信息
      } else {
        delete v?.properties
      }
      items.push(v)
    })

   // add full gift product  在购物车中不添加，在立即购买中添加
   if (flag) {
    const full_gift = $form.find("input[name='id']:checked").data('full-gift')
    if(full_gift) {
      const cartItems = [
        {
          id: Number(full_gift),
          quantity: Number($form.find("input[name='quantity']").val()),
          properties: {}
        }
      ]
      items = items.concat(cartItems)
    }
   }

    return items
  }

  handleErrorMsg(msg) {
    const errWrapper = document.querySelector(".meta .add_cart_error_wrapper")
    if(!errWrapper) return
    errWrapper.toggleAttribute('hidden', !msg);
    errWrapper.textContent = msg
  }

  bindCarAdd() {
    const $form = $(`#AddToCartForm-${meta.product.id}`);
    $form.find(".action").addClass("loading");
    this.handleErrorMsg()

    const items = this.getCheckedItems()
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
    shopifyCartAdd({ items }).then((r) => {
      const full_gift = $form.find("input[name='id']:checked").data('full-gift')
      if(full_gift) {
        const cartItems = [
          {
            id: Number(full_gift),
            quantity: Number($form.find("input[name='quantity']").val()),
            properties: {}
          }
        ]
        shopifyCartAdd({ items: cartItems }).then((d) => {
          if(cart) {
            cart.renderContents( r.items.concat(d.items))
          } else {
            window.location.href = '/cart'
          }
          $form.find(".action").removeClass("loading")
        }).catch((err) => {
          if(cart) {
            cart.renderContents(r)
          } else {
            window.location.href = '/cart'
          }
          $form.find(".action").removeClass("loading")
        })
      } else {
        if(cart) {
          cart.renderContents(r)
        } else {
          window.location.href = '/cart'
        }
        $form.find(".action").removeClass("loading")
      }
    }).catch(err => {
      console.log("oldddddd", err)
      this.handleErrorMsg(err.statusText)
      $form.find(".action").removeClass("loading")
    })
  }

  // Buy it now
  async handleBuy() {
    const $form = $(`#AddToCartForm-${meta.product.id}`);
    $form.find(".action").addClass("loading");
    const items = this.getCheckedItems(true)
    
    try {
      // 生成 checkout url，并跳转
      const checkoutUrl = await createCartAndCheckout(items)
      if (checkoutUrl) {
        window.location.href = checkoutUrl
      }
    } catch(err) {
      // 容错处理
      let str = items.reduce((prev, next) => prev += `${next.id}:${next.quantity},`, '/cart/')
      str = `${str.substring(0, str.length -1)}?traffic_source=buy_now`
      window.location.href = str
    } finally {
      $form.find(".action").removeClass("loading")
    }
  }

  coupon(vId) {
    const me = this, DOM = $(".coupon");
    DOM.empty();

    const copyAndUseText = DOM.attr("data-copy-and-use-text")
    const codeText = DOM.attr("data-code-text")
    const offText = DOM.attr("data-off-text")

    const id = vId || meta.product.variants[0].id;
    const variant = meta.product.variants.find(item => item.id === +id);
    const sku_id = variant.id;
    let price = variant.price;
    getCouponInfo(sku_id, price).then((r) => {
      if (r.data.constructor === Array) { return }

      let begin = r.data.begin_time_str.replace(/-/g, "/");
      let end = r.data.end_time_str.replace(/-/g, "/");

      const h = `
      <svg viewBox="0 0 346 94.2">
        <style type="text/css">.st5{font-weight: 600;}._middle {font-weight: 500; font-size:14px; fill:#fff; text-anchor: middle;}._m {dominant-baseline: middle;}._d {dominant-baseline: alphabetic;}</style>
        <path fill="#FD5000" d="M214,0.2c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8h108c0,4.4,3.6,8,8,8v78c-4.4,0-8,3.6-8,8l-108.1,0 c0-0.3,0.1-0.7,0.1-1c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8c0,0.3,0,0.7,0.1,1L8,94.2c0-4.4-3.6-8-8-8v-78c4.4,0,8-3.6,8-8H214z M222,67.2c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-12C223,67.7,222.6,67.2,222,67.2z M222,49.2c-0.6,0-1,0.4-1,1v12 c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-12C223,49.7,222.6,49.2,222,49.2z M222,31.2c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1 c0.6,0,1-0.4,1-1v-12C223,31.7,222.6,31.2,222,31.2z M222,13.2c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-12 C223,13.7,222.6,13.2,222,13.2z"/>
        <polygon fill="#FFC879" points="21.8,0 0,21.8 0,60.9 60.9,0" />
        <text transform="matrix(0.7 -0.7 0.7 0.7 7 40)" fill="#946040" font-size="8" class="st5">${copyAndUseText}</text>
        <text class="_middle _d" x="120" y="55">
          <tspan style="display:${r.data.type === 2 ? 'none': 'inline-block'};">${r.data.currency}</tspan>
          <tspan class="st5" font-size="45">${r.data.discount}</tspan>

          <tspan class="st5" font-size="45" style="display:${r.data.type === 2 ? 'inline-block': 'none'};">%</tspan>

          <tspan>${r.data.type === 1 ? "" : `${offText}`}</tspan>
        </text>
        <text transform="matrix(1 0 0 1 118 76)" class="_middle _m">${begin}-${end}</text>
        <text transform="matrix(1 0 0 1 284 76)" class="_middle _m">${codeText}:${r.data.coupon_code}</text>
        <circle fill="none" stroke-width="1px" stroke="#fff" cx="285" cy="38.2" r="24.5" />
        <text transform="matrix(1 0 0 1 266 47)" fill="#fff" font-size="24" class="st5">GO</text>
      </svg>
      `;
      DOM.html(h);

      // 先解除绑定在执行
      DOM.find("svg").unbind("click").click(() => {
        copyString(r.data.coupon_code, () => { pushSuccessMessage(me.config.copyCodeSuccess) })
      })
    })
  }

  productShortage(available) {
    const { addToCart, soldOut } = this.config;
    available ? (() => {
      $(".add-to-cart").prop('disabled', false).html(addToCart + `<i class="iconfont jackery-icon-arrow-right"></i>`);
      // $(".shopify-payment-button__button").prop('disabled', false);
      $(".buy-it-now-action").prop('disabled', false);
      $(".shortage").addClass("none")
    })() : (() => {
      $(".add-to-cart").prop('disabled', true).html(soldOut + `<i class="iconfont jackery-icon-arrow-right"></i>`);
      // $(".shopify-payment-button__button").prop('disabled', true);
      $(".buy-it-now-action").prop('disabled', true);
      $(".shortage").removeClass("none")
    })()
  }

  shortageNotice() {
    let me = this, c = $(".shortage_popup .info input"), d = $(".shortage_popup .info button"), e = $(".shortage_popup .agree input");

    function verify() {
      d.prop('disabled', !(verifyEmail(c.val()) && e.is(':checked')))
    }
    e[0].onchange = c[0].onkeyup = function() { verify() }

    d.click(() => {
      let { currentVariant, shortageObj } = me.config;
      let variant = meta.product.variants.find(item => item.id === currentVariant.id);
      d.prop('disabled', true).addClass("btn--loading");
      shortage({
        email: c.val(), sku: currentVariant.sku, sku_goods_name: variant.public_title || variant.name,
        goods_category: shortageObj.collection, goods_name: variant.name, source: "1", cr: shopCR, variant_id: currentVariant.id.toString(),
        goods_url: window.location.pathname.replace("/products/", "")
      }).then(() => {
        $('.shortage_frame .jackery-icon-guanbi').click();
        d.removeClass('btn--loading');
        c.val("");
        pushSuccessMessage(shortageObj.success, 5000)
      }).catch((err) => {
        pushErrorMessage(err.code === 40000 ? err.message : shortageObj.error);
        d.prop('disabled', false).removeClass("btn--loading")
      })
    })
  }

  topBar() {
    const elementToObserve = document.querySelector('.site-header,.jky-header');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          let bar = $('.announcement-bar-show').length;
          let barHeight = bar ? $('.announcement-bar').outerHeight(true) : 0;
          document.querySelector('.tabs-header').style.setProperty("--head-top", `${barHeight + 1}px`)
        }
      });
    });
    const config = { attributes: true };
    observer.observe(elementToObserve, config);
  }

  handleQuantityLimit(currentVariant) {
    if(!currentVariant) return
    if(!document.querySelector(".product-quantity .operate input")) return
    const quantityField = document.querySelector(".product-quantity .operate input")
    if(!currentVariant.inventory_quantity) {
      quantityField.setAttribute("data-max", 1)
      quantityField.setAttribute("max", 1)
      return
    }
    quantityField.setAttribute("data-max", Math.max(currentVariant.inventory_quantity, 1))
    quantityField.setAttribute("max", Math.max(currentVariant.inventory_quantity, 1))
  }

  init() {
    const me = this;
    let { currentVariant, productVariants } = this.config;
    let sw = null;
    let sw2 = null;

    const handleSlideChange = (slide) => { // swiper 切换callback
      try {
        if(slide.querySelector("product-model")) { // 3d model
          try {
            slide.querySelector("product-model").loadContent();
            sw2.allowTouchMove = false;
          } catch (error) {
            console.info("not init 3d model script");
          }
          return;
        } else {
          sw2.allowTouchMove = true;
        }
      } catch (error) {
        
      }
    }

    if (isMobile()) {
      $(".thumbs").empty();
      sw2 = new Swiper(".photo", {
        spaceBetween: 10,
        pagination: { el: ".thumbs", clickable: true },
        on:{
          slideChange: function() {
            handleSlideChange(sw2.slides[this.activeIndex]);
          },
          init: function() {
            setTimeout(() => {
              handleSlideChange(sw2.slides[this.activeIndex]);
            }, 0);
          }
        }
      })
    } else {
      sw = new Swiper(".thumbs .swiper", { 
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true
      });
      sw2 = new Swiper(".photo", {
        spaceBetween: 10,
        // loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        thumbs: {
          swiper: sw
        },
        on:{
          slideChange: function(){
            handleSlideChange(sw2.slides[this.activeIndex]);
          },
          init: function() {
            setTimeout(() => {
              handleSlideChange(sw2.slides[this.activeIndex]);
            }, 0);
          }
        }
      });
      // monitor announcement-bar whether to close
      this.topBar()
    }

    // product quantity
    this.quantity($(".product-quantity .operate"), true);
    this.handleQuantityLimit(currentVariant)

    // 更新 划线价格显示
    this.updateComparePrice(currentVariant)
    try {
      this.renderProductInfo(currentVariant)
    } catch (error) {
      
    }

    // get current extend product and coupon
    this.bundleProduct(currentVariant.id);
    this.coupon(currentVariant.id);

    // bind cart/add
    const form = document.querySelector(`#AddToCartForm-${meta.product.id}`)
    if (form.querySelector('[name="add"]')) {
      form.querySelector('[name="add"]').addEventListener('click', (e) => {
        e.preventDefault();
        this.bindCarAdd();
      })
    }
    // bind buy it now
    if (form.querySelector('[name="buy-it-now"]')) {
      form.querySelector('[name="buy-it-now"]').addEventListener('click', (e) => {
        e.preventDefault();
        this.handleBuy();
      })
    }

    // shortage even
    if ($('.shortage').length > 0) {
      this.productShortage(currentVariant.availability);
      this.shortageNotice()
    }

    // select variant even, change to image / price / url variant / coupon / shortage
    $(".variant-input-wrap input:radio[name='id']").change(function() {
      const v = $(this).val();
      if (!history.replaceState || !v) { return }

      let variant = productVariants[v];

      // rest status
      document.querySelector('.meta .product-quantity input') && (document.querySelector('.meta .product-quantity input').value = 1)
      document.querySelector(".meta .add_cart_error_wrapper") && (document.querySelector(".meta .add_cart_error_wrapper").textContent = '')
      try {
        if(document.querySelector(".meta .operate .jackery-icon-plus")) {
          const max = Number(document.querySelector(".meta .operate input").getAttribute("max"))
          if(max > 1) {
            document.querySelector(".meta .operate .jackery-icon-plus").classList.remove("disabled")
          }
        }
      } catch (error) {
        console.warn(error)
      }

      // change url variant
      const url = new URL(window.location);
      url.searchParams.set("variant", v);
      window.history.pushState({}, "", url);

      // change price/variant title
      $(".meta .price").text(variant.price);
      if(shopId === '10015375438') { // 日本站带jb税收！！！！！！！！！
        $(".meta .price").append("<span>(税込)</span>")
      }
      $(".meta h1").text(variant.title);
      // $(".meta .compare-price").text(variant.compare_at_price);
      // 更新 划线价格显示
      me.updateComparePrice(variant)
      try {
        me.renderProductInfo(variant)
      } catch (error) {
        
      }

      me.config.currentVariant = currentVariant = variant;
      me.handleQuantityLimit(variant)

      // change image
      const index = $(`.photo .swiper-slide[data-media="${currentVariant.media_id}"]`).data("index");
      sw2.slideTo(index, 1000, false);

      // get current extend product and coupon, shortage
      me.coupon(currentVariant.id);
      me.bundleProduct(currentVariant.id);
      me.productShortage(currentVariant.availability)


      if(document.querySelector("#product-form-installment-main")) {
        const input = document.querySelector("#product-form-installment-main").querySelector('input[name="id"]')
        if(!input) return
        input.value = currentVariant.id

        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Fix: afterpay  price_value
      if(document.querySelector("square-placement")) {
        document.querySelector("square-placement").setAttribute("data-amount", currentVariant.price_value)
      }
    })

    const variant = getUrlQueryParams('variant')
    try {
      document.querySelectorAll('[data-product-label]').forEach(it => {
        const productId = it.dataset.productLabel
        if(variant) {
          if (productId == variant) {
            it.click()
            const { productVariants } = me.config
            const media_id = productVariants[variant].media_id
            // change image
            const index = $(`.photo .swiper-slide[data-media="${media_id}"]`).data("index");
            sw2.slideTo(index, 0, false);

            throw new Error('LoopInterrupt')
          }
        } else {
          if (productId == currentVariant.id) {
            it.previousElementSibling.setAttribute('checked', 'checked')
  
            // change image
            const index = $(`.photo .swiper-slide[data-media="${currentVariant.media_id}"]`).data("index");
            sw2.slideTo(index, 1000, false);
          }
        }
      })
    } catch (e) {
      if (e.message !== 'LoopInterrupt')  throw e
    }
    

    document.addEventListener('DOMContentLoaded', () => {
      new ProductDetailVideo(
        {
          el: '.photovolatic-setup-wrap'
        }
      )
    })
  }
}

window.MainProduct = Product;
window.HelpToChoose = HelpToChoose;